import { useState, useCallback } from 'react';
import { pw9201Api, F90B } from '../../../services/pw9201Api';

export function usePW9201Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw9201Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const resolveAllNames = useCallback(async (master: Partial<F90B>) => {
    const entries: [string, string, string][] = [
      ['department', 'department', master.f90b_11 || ''],
      ['employee', 'employee', master.f90b_12 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw9201Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveSingleName, resolveAllNames, clearNames };
}
